import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './consultationsIndicator.module.scss';

function ConsultationsIndicator({ consultations }) {
  return (
    <Box className={styles.consultationsIndicator}>
      <Icon
        icon="icon-consultas"
        className={styles.consultationsIndicatorIcon}
      />
      <Text className={styles.consultationsIndicatorText}>{consultations}</Text>
    </Box>
  );
}

export default ConsultationsIndicator;
